import { get } from 'object-path-immutable';
import { SLIDEOUT } from 'lib/presentation';
import {
  calculateOverridePaths,
  styleToThemeStyle,
  augmentedWrap,
} from './utils';

const PATHS = {
  root: 'style',
  backdrop: 'backdrop',
  pointer: 'pointer',
};

export const addTheme = (content, selectedVariant, preserveOverrides) => {
  const updated = augmentedWrap(content);

  if (content.style) {
    updated.updateStyle(
      PATHS.root,
      { theme: selectedVariant },
      preserveOverrides
    );
  }
  if (content.backdrop) {
    updated.updateStyle(
      PATHS.backdrop,
      {
        theme: `${selectedVariant}.backdrop`,
      },
      preserveOverrides
    );
  }
  if (content.pointer) {
    updated.updateStyle(
      PATHS.pointer,
      { theme: `${selectedVariant}.pointer` },
      preserveOverrides
    );
  }

  return updated.value();
};

export const overrides = ({ compiledTheme, content }) =>
  [
    calculateOverridePaths({
      compiledTheme,
      content,
      path: PATHS.root,
      ignore:
        content.presentation === SLIDEOUT
          ? ['horizontalAlignment', 'verticalAlignment', 'width']
          : [],
    }),
    calculateOverridePaths({
      compiledTheme,
      content,
      path: PATHS.backdrop,
      pathName: 'backdrop',
    }),
    calculateOverridePaths({
      compiledTheme,
      content,
      path: PATHS.pointer,
      // the pointer property names all prefix with "pointer", so this pathName gives it grammatical/contextual sense
      pathName: 'tooltip',
    }),
  ].flat();

export const extractStyles = content => ({
  $style: styleToThemeStyle({
    style: get(content, PATHS.root),
    ignore:
      content.presentation === SLIDEOUT
        ? ['horizontalAlignment', 'verticalAlignment', 'width']
        : [],
  }),
  ...(content.backdrop && {
    backdrop: {
      $style: styleToThemeStyle({ style: get(content, PATHS.backdrop) }),
    },
  }),
  ...(content.pointer && {
    pointer: {
      $style: styleToThemeStyle({ style: get(content, PATHS.pointer) }),
    },
  }),
});
